import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslateCustomizationService {
  private translateInstances: { [key: string]: TranslateService } = {};

  constructor(private translateService: TranslateService) {}

  public async loadLanguage(lang: string): Promise<TranslateService> {
    if (!this.translateInstances[lang]) {
      const newTranslateInstance = new TranslateService(
        this.translateService.store,
        this.translateService.currentLoader,
        this.translateService.compiler,
        this.translateService.parser,
        this.translateService.missingTranslationHandler,
        true,
        true,
        false,
        'en'
      );
      await firstValueFrom(newTranslateInstance.use(lang));
      this.translateInstances[lang] = newTranslateInstance;
    }
    return this.translateInstances[lang];
  }
}
